export default class MasonryComponent{

  constructor(){
    this.init = this.init.bind(this);

    this.init();
  }

  init(){
    let $grid = $('.grid').masonry({
      itemSelector: '.grid-item',
      percentPosition: true,
      horizontalOrder: true,
      masonry: {
        // use element for option
        columnWidth: '.grid-sizer',
      },
    });

    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/masonry.js